'use client'

import { WishlistShareSectionDS } from '@src/components/blocks/wishlist-share-section-ds'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import WishlistShareSectionLegacy, { WishlistShareSectionProps } from './wishlist-share-section-legacy'

export type { WishlistShareSectionProps }

function WishlistShareSection(props: WishlistShareSectionProps) {
  if (shouldUseDesignSystem()) {
    return <WishlistShareSectionDS {...props} />
  }
  return <WishlistShareSectionLegacy {...props} />
}

export default WishlistShareSection
